// //////////////////////////////////////////////////////////////////
// Parse Snowflake Responses
// //////////////////////////////////////////////////////////////////
import { snowflakeToJsTypes } from '~/scripts/snowflake/snowflakeConversions'

export function snowflakeParseResponse(response: any, returnType: string) {
  try {
    // Check For Errors
    if (response.error)
      return { status: 'ERROR', error: response.error } as SnowflakeResponse

    // Parse Regular Response to JSON
    const schema = response.resultSetMetaData?.rowType
    const headers = schema ? schema.map((column: any) => column.name) : []
    const rows = response.data
    const typeConversions: any = {}

    schema.forEach((column: any) => {
      typeConversions[column.name] = column.type
    })

    let data: any = []

    // If Return JSON Type
    if (returnType === 'json') {
      // Create JSON Array of Object Combining Headers and Data Rows
      rows.forEach((row: any) => {
        const rowObject: any = {}

        headers.forEach((header: any, index: number) => {
          // Convert to Javascript Type
          rowObject[header] = snowflakeToJsTypes(row[index], typeConversions[header])
        })
        data.push(rowObject)
      })
    }
    else { data = rows }

    const responseObject = { status: 'SUCCESS', data, schema, requestId: response.requestId, queryId: response.statementHandle } as SnowflakeResponse

    console.log('Snowflake Response Parsed', responseObject)

    return responseObject
  }
  catch (error: any) {
    return { status: 'ERROR', error: `Parsing Snowflake Response FAILED! ${error}`, requestId: response.requestId, queryId: response.statementHandle } as SnowflakeResponse
  }
}
